import React from 'react';
import { ResponsiveContainer, ComposedChart, Bar, XAxis, YAxis, CartesianGrid, ReferenceLine, Label, Line } from 'recharts';

class Results extends React.Component {

    render() {
        var Age = 0
        var RaceAA = 0
        var RaceEA = 0
        var EthnicityHispanic = 0
        var Smoker = 0
        var RiskCloseContact = 0
        var RiskOtherExposure = 0
        var Temperature = 0
        var Fever = 0
        var HistoryOfFever = 0
        var LossOfTasteSmell = 0
        var MuscleAche = 0
        var SoreThroat = 0
        var CoughWithoutSputum = 0
        var Wheezing = 0
        var Cancer = 0
        var COPD = 0
        var Asthma = 0
        var OtherLungDisease = 0
        var SystolicBloodPressure = 0
        var HighBloodPressure = 0
        var data
        var beta = 0
        var riskScore, classifiedRisk, calculatedRiskScore
        var moreThan = 0
        var moreThanAndInfected = 0
        var closeAndInfected = []
        var shouldStop = false
        var after = 0

        // Set Age
        Age = Math.round(this.props.responses["age"])
        
        // Set Race
        if (this.props.responses["race"] === 2.0) {
            RaceAA = 1.0
        } else if (this.props.responses["race"] === 4.0) {
            RaceEA = 1.0
        }
        
        // Set Ethnicity
        if (this.props.responses["ethnicity"] === 0) {
            EthnicityHispanic = 1.0
        }
        
        // Set Smoker
        if (this.props.responses["isSmoker"] === 0) {
            Smoker = 1.0
        }
        
        // Set Close Contact
        if (this.props.responses["householdOrInstituitionalRisk"] === 0) {
            RiskCloseContact = 1.0
        }
        
        // Set Other Risk
        if (this.props.responses["otherRisk"] === 0.0) {
            RiskOtherExposure = 1.0
        }
        
        // Set Temperature or Fever
        if (this.props.responses["temperature"] === 0.0) {
            Fever = 1.0
        } else if (this.props.responses["temperature"] > 1.0) {
            Temperature = (this.props.responses["temperature"] - 32) * (5/9)
        }
        
        // Set History of Fever
        if (this.props.responses["historicalFever"] === 0.0) {
            HistoryOfFever = 1.0
        }
        
        // Set Lost Taste or Smell
        if (this.props.responses["lostTasteOrSmell"] === 0.0) {
            LossOfTasteSmell = 1.0
        }
        
        // Set Muscle Aches
        if (this.props.responses["hasMuscleAches"] === 0.0) {
            MuscleAche = 1.0
        }
        
        // Set Sore Throat
        if (this.props.responses["hasSoreThroat"] === 0.0) {
            SoreThroat = 1.0
        }
        
        // Set Cough Without Sputum
        if (this.props.responses["hasCoughWithoutSputum"] === 0.0) {
            CoughWithoutSputum = 1.0
        }
        
        // Set Wheezing
        if (this.props.responses["isWheezing"] === 0.0) {
            Wheezing = 1.0
        }
        
        // Set Cancer
        if (this.props.responses["hasCancer"] === 0.0) {
            Cancer = 1.0
        }
        
        // Set COPD
        if (this.props.responses["hasCOPD"] === 0.0) {
            COPD = 1.0
        }
        
        // Set Asthma
        if (this.props.responses["hasAsthma"] === 0.0) {
            Asthma = 1.0
        }
        
        // Set Other Lung Disease
        if (this.props.responses["hasOtherLungDisease"] === 0.0) {
            OtherLungDisease = 1.0
        }
        
        // Set High Blood Pressure and Systolic Blood Pressure
        if (this.props.responses["systolicBloodPressure"] === 0.0) {
            HighBloodPressure = 1.0
        } else if (this.props.responses["systolicBloodPressure"] > 1.0) {
            SystolicBloodPressure = this.props.responses["systolicBloodPressure"]
        }

        if (this.props.binaryChoice) {
            console.log("Categorical Path")
            beta = -2.7846
            beta += 1.1607*RiskCloseContact
            beta += 0.4858*RiskOtherExposure
            beta += 0.9167*RaceAA
            beta -= 0.3614*RaceEA
            beta += 1.3163*EthnicityHispanic
            beta += 0.0241*Age
            beta -= 0.5087*SoreThroat
            beta += 0.4130*CoughWithoutSputum
            beta -= 0.6115*Wheezing
            beta += 0.5070*HistoryOfFever
            beta += 0.4570*MuscleAche
            beta += 1.9577*LossOfTasteSmell
            beta -= 0.8304*Smoker
            beta -= 0.7691*Cancer
            beta -= 0.3069*COPD
            beta -= 0.3568*Asthma
            beta -= 0.6334*OtherLungDisease
            beta += 0.8676*Fever
            beta -= 0.2680*HighBloodPressure
            data = require("../data/simulated_pop.cat10000_predicted.json")
        } else {
            console.log("Continuous Path")
            beta = -21.8613
            beta += 1.1686*RiskCloseContact
            beta += 0.4684*RiskOtherExposure
            beta += 0.9016*RaceAA
            beta -= 0.3568*RaceEA
            beta += 1.3142*EthnicityHispanic
            beta += 0.0251*Age
            beta -= 0.4822*SoreThroat
            beta += 0.4137*CoughWithoutSputum
            beta -= 0.6106*Wheezing
            beta += 0.3723*HistoryOfFever
            beta += 0.4417*MuscleAche
            beta += 1.9584*LossOfTasteSmell
            beta += 0.5386*Temperature
            beta -= 0.00671*SystolicBloodPressure
            beta -= 0.7839*Smoker
            beta -= 0.7902*Cancer
            beta -= 0.3085*COPD
            beta -= 0.3445*Asthma
            beta -= 0.6586*OtherLungDisease
            data = require("../data/simulated_pop10000_predicted.json")
        }

        riskScore = 100 * (Math.pow(Math.E,beta)/(1 + Math.pow(Math.E, beta)))

        calculatedRiskScore = Math.round(riskScore * 100)/100

        if (calculatedRiskScore <= 5) {
            classifiedRisk = "very low"
        } else if (calculatedRiskScore <= 28) {
            classifiedRisk = "low"
        } else if (calculatedRiskScore <= 44) {
            classifiedRisk = "moderate"
        } else if (calculatedRiskScore <= 66) {
            classifiedRisk = "relatively high"
        } else if (calculatedRiskScore <= 90) {
            classifiedRisk = "high"
        } else {
            classifiedRisk = "very high"
        }

        // Setup Binning
        var binnedData = []
        // var binCount = 0
        const binStep = 0.01
        var currBin = 0.99
        // var totalInfected = 0
        var totalInfectedInBin = 0
        var totalInBin = 0

        for (let i = 0; i < data.length; i++) {
            // if (data[i][1] === 1) {
            //     totalInfected += 1
            // }

            if (data[i][0] >= currBin) {
                if (data[i][1] === 1) {
                    totalInfectedInBin += 1
                }
                totalInBin += 1
            } else if (data[i][0] < currBin) {
                if (totalInfectedInBin === 0) {
                    binnedData.push({"index": currBin.toPrecision(2)*100 + 1, "infected": 0.00})
                } else {
                    binnedData.push({"index": currBin.toPrecision(2)*100 + 1, "infected": (totalInfectedInBin/totalInBin).toPrecision(2)*100})
                }
                currBin -= binStep // move to next bin
                totalInBin = 0
                totalInfectedInBin = 0
            }

            if (data[i][0] > riskScore / 100) {
                moreThan += 1
                if (data[i][1] === 1) {
                    moreThanAndInfected += 1
                }
            }

            if (!shouldStop) {
                closeAndInfected.push(data[i][1])
                if (closeAndInfected.length > 100) {
                    closeAndInfected.splice(0,1)
                }
                if (data[i][0] < riskScore / 100) {
                    after += 1
                }
                if (closeAndInfected.length === 100 && after >= 50) {
                    shouldStop = true
                }
            }
        }

        var closeAndInfectedSum = 0
        for (let i = 0; i < closeAndInfected.length; i++) {
            closeAndInfectedSum += closeAndInfected[i]
        }

        for (let i = 0; i < binnedData.length; i++) {
            var sum = 0
            if (i < 5) {
                // First 5 values are not guaranteed
                for (let j = 0; j < i + 6; j++) {
                    sum += binnedData[j].infected
                }
                binnedData[i].avgInfected = sum / (i+6)
            } else if (i > binnedData.length - 6) {
                // Last 5 values are not guaranteed
                for (let j = i - 5; j < binnedData.length; j++) {
                    sum += binnedData[j].infected
                }
                binnedData[i].avgInfected = sum / (binnedData.length-(i-5))
            } else {
                for (let j = i - 5; j < i + 5; j++) {
                    sum += binnedData[j].infected
                }
                binnedData[i].avgInfected = sum / 10
            }
        }

        console.log(binnedData)

        return (
            <div class="card">
                <h1 class="text-center m-3">COVID-R Assessment Results</h1>
                <hr class="m-0"/>
                <div class="m-3 p-3">
                    <p>
                        Your computed Risk Score was {calculatedRiskScore} out of 100. Your probability of COVID-19 infection is {classifiedRisk}.
                    </p>
                    <p>
                        For your reference, in the general US population, 
                        about 11% people have been or are currently infected 
                        with COVID-19. The median risk score for the infected 
                        is 53.0; the median risk score for the uninfected is 
                        19.4. In the general US population, {moreThan} people 
                        out of 10,000 have a risk score the same 
                        as or higher than your score, and {moreThanAndInfected} of
                        them are infected with COVID-19. In the general 
                        US population, out of 100 people with similar risk 
                        scores as yours, {closeAndInfectedSum} are infected with COVID-19. 
                        Please note that there are people infected with 
                        COVID-19 without symptoms. Even if you have a 
                        low computed risk score, please contact your 
                        healthcare provider immediately if you have any doubts.
                    </p>
                    <p>
                        Illustrated below is the relationship between risk 
                        score and percentage of people who are infected in 
                        the US population from a dataset simulated from real 
                        data. Your risk score is represented by the red line 
                        for your reference.
                    </p>
                </div>
                <div className="line-chart-wrapper mx-4" style={{height: '400px'}}>
                    <ResponsiveContainer>
                        <ComposedChart
                            data={binnedData}
                            margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                        >
                            <XAxis dataKey="index" type="number" class="m-2">
                                <Label value="Risk Score" offset={0} position="bottom" />
                            </XAxis>
                            {/* <YAxis class="m-3">
                                <Label value="Proportion (Percent of Infected)" offset={5} angle={-90} position="insideBottomLeft" />
                            </YAxis> */}
                            <YAxis class="m-3">
                                <Label value="Percentage of Infected" offset={5} angle={-90} position="insideBottomLeft" />
                            </YAxis>
                            {/* <Tooltip /> */}
                            <CartesianGrid stroke="#f5f5f5" />
                            <Bar dataKey="infected" barSize={10} fill="#413ea0" />
                            <ReferenceLine x={riskScore} stroke="red" strokeWidth="3" label=""/>
                            <Line type="monotone" dataKey="avgInfected" stroke="#ff7300" />
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>
                <button type="button" class="btn btn-primary m-3" onClick={this.props.restartAssessment}>Restart Assessment</button>
            </div>
        );
    }
}

export default Results;
